var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDocumentPen(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: 20,
    viewBox: "0 0 21 20",
    width: 21,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd",
    transform: "translate(-2 -2)"
  }, /*#__PURE__*/React.createElement("g", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    transform: "translate(3 3)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m11.7220001 17.7069995h.0000001c-.187493.187549-.441805.293-.707.293h-2.01500006v-2.015.0002134c0-.265195.10534-.51953.292849-.707063l6.76899996-6.77399997-.0000001.00000012c.672054-.672131 1.76173-.672193 2.43386-.0001387.0000462.00004615.0000923.00009231.0001385.00013847v.00000001c.672131.671273.672826 1.76031997.0015531 2.43244997-.0005174.0005181-.0010351.0010358-.0015531.0015532z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m13.564 11.009 2.43 2.43"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m17.7180001 11.7149995.9.9.0000001.0000001c.473756.474684.473756 1.24332-.0000001 1.718l-1.641 1.641"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m4 6.001h6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m4 10.001h4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m6 18h-3c-1.65685 0-3-1.3431505-3-3v-12c0-1.65685 1.34315-3 3-3h12c1.6568499 0 3 1.34315 3 3v2"
  })), /*#__PURE__*/React.createElement("path", {
    d: "m0 24v-24h24v24z"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDocumentPen);
export default __webpack_public_path__ + "static/media/document-pen.2b5e02ef0a1872903aa7e22a586c5872.svg";
export { ForwardRef as ReactComponent };